import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './twoColumnSection.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function twoColumnSection(props) {

    const sectionRef = useRef();
    const textRef = useRef();
    const logoRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([textRef.current], {
        //     opacity: 0,
        //     x: -80
        // });

        // TweenMax.set([logoRef.current], {
        //     opacity: 0,
        //     x: 80
        // });

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

                    // TweenMax.to(
                    //     logoRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.25
                    //     } 
                    // );

                    // TweenMax.to(
                    //     textRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.65,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );
                    $(sectionRef.current).addClass('anim-complete');
                }
            });
        }

    });

    let desktopImage = (props.desktopImage) ? props.desktopImage.image.asset.url : '';
    let imageOne = (props.imageOne) ? props.imageOne.image.asset.url : '';
    let imageTwo = (props.imageTwo) ? props.imageTwo.image.asset.url : '';

    return (
        <div className={styles.twoColumnSection} ref={sectionRef}>
            <div className={styles.sectionContainer}>
                <div className={styles.desktopImage}>
                    <img src={desktopImage} alt="" ref={logoRef} />
                </div>
                <div className={styles.textWrap} ref={textRef}>
                    <h2>{props.heading}</h2>
                    <div className={styles.content}>
                        <PortableText blocks={props.content} />
                    </div>
                </div>
                <div className={styles.logos}>
                    <div className={styles.logo}>
                        <img src={imageOne} alt="" />
                    </div>
                    <div className={styles.logo}>
                        <img src={imageTwo} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default twoColumnSection;